import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Sparkles } from "lucide-react";
import "./Home.css";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
  {
    title: 'Peinture',
    description: 'Peinture intérieure et extérieure de haute qualité',
    image: '/images/peinture1.jpg'  // derniere image page acceuil 
  },
  {
    title: 'Pose d\'argile',
    description: 'Application d\'enduit à l\'argile naturelle et écologique',
    image: '/images/argile1.jpg'  // pareil ici
  }
];

  const features = [
    "Rénovation complète ou partielle",
    "Travaux personnalisés",
    "Matériaux de qualité",
    "Finitions soignées",
  ];

  return (
    <div className="home-page">
      
      <section className="hero-section">
        <div className="hero-background">
          <div className="hero-shape shape-1"></div>
          <div className="hero-shape shape-2"></div>
          <div className="hero-shape shape-3"></div>
        </div>

        <div className="container hero-content">
          <div className="hero-text fade-in">
            <div className="hero-badge">
              <Sparkles size={16} />
              <span>Votre partenaire rénovation</span>
            </div>
            <h1>
              Votre projet,
              <br />
              <span className="gradient-text">Notre travail</span>
            </h1>
            <p className="hero-description">
              La société Lomatout faire est le partenaire idéal dans la
              rénovation de votre habitation ! Que ce soit un nouveau bien ou
              une ancienne demeure, une rénovation complète ou partielle, nous
              mettons tout en œuvre pour vous aider à réaliser vos rêves et
              faire de votre maison, votre cocon.
            </p>
            <div className="hero-actions">
              <Link to="/contact" className="btn btn-primary">
                Contactez-nous
                <ArrowRight size={20} />
              </Link>
              <Link to="/portfolio" className="btn btn-secondary">
                Découvrir nos réalisations
              </Link>
            </div>
          </div>

          <div className="hero-image scale-in">
  <img 
    src="/images/hero.jpg"  // prem image acceuil ici 
    alt="Rénovation moderne"
  />
</div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="features-grid">
            {features.map((feature, index) => (
              <div
                key={index}
                className="feature-card fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CheckCircle2 size={24} />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text slide-in-left">
              <h2>Excellence et Savoir-faire</h2>
              <p>
                Nous effectuons un large panel de travail, de réalisations plus
                spécifiques aux créations, montages, applications ainsi que
                réparations, nos services seront à la hauteur de vos espérances.
              </p>
              <p>
                Notre équipe de professionnels qualifiés met son expertise à
                votre service pour garantir des résultats exceptionnels qui
                dépasseront vos attentes.
              </p>
              <Link to="/portfolio" className="btn btn-outline">
                Voir tous nos services
                <ArrowRight size={18} />
              </Link>
            </div>
            
            <div className="about-image slide-in-right">
          <img 
         src="/images/about.jpg"  // image de milieu d'acceuil
    alt="Notre expertise"
  />
</div>
          </div>
        </div>
      </section>

      
      <section className="services-preview">
        <div className="container">
          <div className="section-header">
            <h2 className="fade-in">Nos Services</h2>
            <p className="fade-in">Découvrez un aperçu de nos réalisations</p>
          </div>

          <div className="services-grid">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-card scale-in"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="service-image">
                  <img src={service.image} alt={service.title} />
                  <div className="service-overlay">
                    <Link to="/portfolio" className="overlay-link">
                      Voir plus
                      <ArrowRight size={20} />
                    </Link>
                  </div>
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="services-cta fade-in">
            <Link to="/portfolio" className="btn btn-primary">
              Voir tout le portfolio
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

      
      <section className="cta-section">
        <div className="container">
          <div className="cta-content fade-in">
            <h2>Prêt à transformer votre intérieur ?</h2>
            <p>Contactez-nous dès aujourd'hui pour discuter de votre projet</p>
            <Link to="/contact" className="btn btn-white">
              Demander un devis gratuit
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
